import { CircleHelp } from "lucide-react";
import { Popover } from "radix-ui";

/**
 * A small "?" that opens a short explanation of a number or term. A click (or tap) opens it, so it works on
 * phones too, where nothing can be hovered.
 */
export function HelpTip({ topic, children }: { topic: string; children: string }) {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          type="button"
          aria-label={`What is ${topic.toLowerCase()}?`}
          className="inline-flex size-5 items-center justify-center rounded-full text-faint transition-colors hover:text-ink data-[state=open]:text-ink"
        >
          <CircleHelp className="size-3.5" aria-hidden="true" />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          side="top"
          align="start"
          sideOffset={6}
          collisionPadding={12}
          className="z-50 max-w-72 rounded-xl border border-border bg-surface p-3 text-[13px] leading-relaxed text-ink-2 shadow-xl outline-none"
        >
          <p className="mb-1 font-bold text-ink">{topic}</p>
          {children}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
